import { CanMatchFn } from '@angular/router';
import { isAppHost } from './status-viewer.utils';

/**
 * Claims the whole origin for the status viewer when the request arrives on an alias
 * host or a customer's custom domain.
 *
 * On those hosts there is no application to route to — the hostname *is* the page
 * identifier — so matching here keeps every other route table from ever being consulted.
 * On the app host this returns false and routing continues normally.
 */
export const publicStatusHostGuard: CanMatchFn = () => {
  if (typeof window === 'undefined' || !window.location?.hostname) {
    return false;
  }

  return !isAppHost(window.location.hostname);
};
